import * as immutable from 'object-path-immutable';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
//import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import AllReducers from './Areas/Common/Reducers/AllReducers';


const combinedReducers = combineReducers({
  ...AllReducers
});

const rootReducer = (state, action) => {
  if (action.type === '__SET_DIRECT') {
    state = (immutable).set(state, action.prop, action.newValue);
  }
  return combinedReducers(state, action);
}

// Create our redux store and apply middleware
const talentFormsStore = createStore(rootReducer, compose(
  applyMiddleware(thunk),
  window.devToolsExtension ? window.devToolsExtension() : f => f
));


export default talentFormsStore;